import styled from 'styled-components';

export const StyledSocialProof = styled.div`
  background-color: ${({ theme }) => theme.colors.white};

  .social-proof {
    padding: 80px 24px;
    max-width: 1200px;
    margin: 0 auto;

    &__header {
      text-align: center;
      margin-bottom: 48px;

      h2 {
        margin-top: 8px;
        color: ${({ theme }) => theme.colors.black};
      }
    }

    &__stats {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 24px;
      margin-bottom: 64px;
    }

    &__stat-item {
      text-align: center;
      padding: 28px 16px;
      background-color: ${({ theme }) => theme.colors.white};
      border-radius: 12px;
      border: 1px solid ${({ theme }) => theme.colors.iron};
    }

    &__stat-icon {
      margin-bottom: 12px;

      svg {
        color: ${({ theme }) => theme.colors.mainBlue};
      }
    }

    &__stat-value {
      margin-bottom: 4px;
    }

    &__stat-label {
      p {
        color: ${({ theme }) => theme.colors.raven};
      }
    }

    &__features-summary {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
    }

    &__feature-block {
      background-color: ${({ theme }) => theme.colors.white};
      border: 1px solid ${({ theme }) => theme.colors.iron};
      border-radius: 12px;
      padding: 28px;
    }

    &__feature-block-title {
      margin-bottom: 12px;

      p {
        color: ${({ theme }) => theme.colors.mainOrange};
      }
    }

    &__feature-block-text {
      p {
        color: ${({ theme }) => theme.colors.mineShaft};
      }
    }

    @media (max-width: 900px) {
      &__stats {
        grid-template-columns: repeat(2, 1fr);
      }

      &__features-summary {
        grid-template-columns: 1fr;
      }
    }

    @media (max-width: 600px) {
      padding: 48px 16px;
    }
  }
`;
